export default __webpack_public_path__ + "static/media/carousel-prev.914ad723.svg";